// Which kind a toast is: 'success', 'destructive' (failure), 'blocked'
// (stopped by a rule: permission, approval, quiet hours) or 'default'
// (neutral, no icon). Most call sites pass only a title, so a toast without an
// explicit `variant` is classified from that title. An explicit variant always
// wins. A title that matches none of the lists stays neutral: a wrong green
// tick on a bad outcome is worse than no icon.
const BLOCKED = /permission needed|not approved|quiet hours|read.?only|not allowed|blocked|managed in/i;
const FAILED = /fail|couldn.?t|could not|can.?t\b|cannot|error|invalid|unable|not found|required|expired|denied|too many|did not|\bnot\b|add at least|give the|wrong|incorrect|missing|must |^(select|pick|enter|please|choose|every)\b/i;
const SUCCESS = /saved|created|updated|deleted|removed|added|sent|copied|merged|archived|booked|rescheduled|changed|complete|submitted|generated|reassigned|duplicated|published|invited|kept|joined|welcome|connected|uploaded|restored|resent|approved|scheduled|assigned|marked|cleared|renamed|moved|accepted|done/i;

export function toastKind({ variant, title }) {
  if (variant) return variant;
  if (typeof title !== 'string') return 'default';
  if (BLOCKED.test(title)) return 'blocked';
  if (FAILED.test(title)) return 'destructive';
  if (SUCCESS.test(title)) return 'success';
  return 'default';
}
